<template>
  <div id="privacy-policy">
    <!-- Header -->
    <Header />
    
    <!-- Page Content -->
    <div class="min-h-screen bg-gray-50 py-16">
      <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <!-- Header -->
        <div class="text-center mb-12">
          <h1 class="text-4xl font-bold text-text-primary mb-4">Privacy Policy</h1>
          <p class="text-lg text-text-secondary">Last Updated: December 16, 2025</p>
        </div>

        <!-- Content -->
        <div class="bg-white rounded-lg shadow-lg p-8 prose max-w-none">
          <h2 class="text-2xl font-bold mb-4">Privacy Policy</h2>
          <p class="mb-4">This privacy policy applies to the Kedi Kafesi Sim app (hereby referred to as "Application") for mobile devices that was created by (hereby referred to as "Service Provider") as an Ad Supported service. This service is intended for use "AS IS".</p>
          
          <h3 class="text-xl font-bold mt-6 mb-3">Information Collection and Use</h3>
          <p class="mb-3">The Application collects information when you download and use it. This information may include information such as:</p>
          <ul class="list-disc pl-6 mb-4">
            <li>Your device's Internet Protocol address (e.g. IP address)</li>
            <li>The pages of the Application that you visit, the time and date of your visit, the time spent on those pages</li>
            <li>The time spent on the Application</li>
            <li>The operating system you use on your mobile device</li>
          </ul>
          <p class="mb-4">The Application does not gather precise information about the location of your mobile device.</p>
          <p class="mb-4">The Service Provider may use the information you provided to contact you from time to time to provide you with important information, required notices and marketing promotions.</p>
          <p class="mb-4">For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information. The information that the Service Provider request will be retained by them and used as described in this privacy policy.</p>
          
          <h3 class="text-xl font-bold mt-6 mb-3">Third Party Access</h3>
          <p class="mb-3">Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement.</p>
          <p class="mb-3">Please note that the Application utilizes third-party services that have their own Privacy Policy about handling data. Below are the links to the Privacy Policy of the third-party service providers used by the Application:</p>
          <ul class="list-disc pl-6 mb-4">
            <li><a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">Google Play Services</a></li>
            <li><a href="https://support.google.com/admob/answer/6128543?hl=en" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">AdMob</a></li>
            <li><a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">Google Analytics for Firebase</a></li>
            <li><a href="https://firebase.google.com/support/privacy/" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">Firebase Crashlytics</a></li>
            <li><a href="https://www.facebook.com/about/privacy/update/printable" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">Facebook</a></li>
            <li><a href="https://www.applovin.com/privacy/" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">AppLovin</a></li>
            <li><a href="https://www.adjust.com/terms/privacy-policy" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">Adjust</a></li>
          </ul>
          <p class="mb-3">The Service Provider may disclose User Provided and Automatically Collected Information:</p>
          <ul class="list-disc pl-6 mb-4">
            <li>as required by law, such as to comply with a subpoena, or similar legal process;</li>
            <li>when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;</li>
            <li>with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.</li>
          </ul>
          
          <h3 class="text-xl font-bold mt-6 mb-3">Opt-Out Rights</h3>
          <p class="mb-4">You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.</p>
          
          <h3 class="text-xl font-bold mt-6 mb-3">Data Retention Policy</h3>
          <p class="mb-4">The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please contact them at contact@playcatgames.com and they will respond in a reasonable time.</p>
          
          <h3 class="text-xl font-bold mt-6 mb-3">Children</h3>
          <p class="mb-4">The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.</p>
          <p class="mb-4">The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect personally identifiable information from children under 13 years of age. In the case the Service Provider discover that a child under 13 has provided personal information, the Service Provider will immediately delete this from their servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (contact@playcatgames.com) so that they will be able to take the necessary actions.</p>
          
          <h3 class="text-xl font-bold mt-6 mb-3">Security</h3>
          <p class="mb-4">The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains.</p>
          
          <h3 class="text-xl font-bold mt-6 mb-3">Changes</h3>
          <p class="mb-4">This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.</p>
          <p class="mb-4"><strong>This privacy policy is effective as of 2025-12-16</strong></p>
          
          <h3 class="text-xl font-bold mt-6 mb-3">Your Consent</h3>
          <p class="mb-4">By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.</p>
          
          <h3 class="text-xl font-bold mt-6 mb-3">Contact Us</h3>
          <p class="mb-4">If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at <a href="mailto:contact@playcatgames.com" class="text-primary hover:underline">contact@playcatgames.com</a>.</p>
        </div>

        <!-- Back Button -->
        <div class="text-center mt-8">
          <router-link 
            to="/" 
            class="inline-flex items-center px-6 py-3 bg-primary hover:bg-indigo-700 text-white font-semibold rounded-lg transition-colors duration-300"
          >
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
            {{ $t('common.backToHome') }}
          </router-link>
        </div>
      </div>
    </div>
    
    <!-- Footer -->
    <Footer />
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'PrivacyPolicy',
  components: {
    Header,
    Footer
  },
  setup() {
    const { locale, t } = useI18n()
    
    const hasFullTranslation = computed(() => {
      try {
        // Check if full translation exists by testing a nested key
        const testTranslation = t('legal.privacy.sections.overview.content')
        return testTranslation && !testTranslation.startsWith('legal.privacy.sections')
      } catch (error) {
        return false
      }
    })
    
    const getCurrentLanguage = () => {
      return locale.value
    }
    
    const changeToLanguage = (langCode) => {
      locale.value = langCode
      localStorage.setItem('language', langCode)
    }
    
    return {
      hasFullTranslation,
      getCurrentLanguage,
      changeToLanguage
    }
  }
}
</script>

<style scoped>
#privacy-policy {
  width: 100%;
  overflow-x: hidden;
}

.prose h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.prose h2:first-child {
  margin-top: 0;
}

.prose p {
  color: #64748b;
  line-height: 1.75;
  margin-bottom: 1rem;
}

.prose ul {
  list-style-type: disc;
  list-style-position: inside;
  color: #64748b;
  margin-bottom: 1rem;
}

.prose li {
  line-height: 1.75;
  margin-bottom: 0.5rem;
}
</style>